export const formatFilterValue = (value: unknown): string | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }
  
  if (Array.isArray(value)) {
    return value.length > 0 ? value.join(',') : undefined;
  }
  
  return String(value);
};
